"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useRealtimeChannel;
// hooks/useRealtimeChannel.ts
const react_1 = require("react");
function useRealtimeChannel({ socket, channel, event, onMessage, }) {
    (0, react_1.useEffect)(() => {
        if (!socket)
            return;
        console.log(`🔗 Joining channel: ${channel}`);
        socket.emit("join", channel);
        const handler = (data) => onMessage(data);
        socket.on(event, handler);
        return () => {
            console.log(`🚪 Leaving channel: ${channel}`);
            socket.off(event, handler);
            socket.emit("leave", channel);
        };
    }, [socket, channel, event, onMessage]);
}
